import styled, { css } from 'styled-components'
// import { BREAK_POINT_MD } from '@CSSVars/variables'
import { BUTTON_HOVER, TERTIARY_COLOR, TEXT_GREY } from '@CSSVars/colors'


export const _ChartSummaryBlock = styled.div`
  vertical-align: top;
`

export const _Square = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 7px;


`
export const _Title = styled.span`
  font-size: 14px;
  line-height: 22px;
  @media screen and (max-width: 424px) {
    font-size: 12px;
    line-height: 18px;
  }
`
export const _TitleContainer = styled.div`
  margin-bottom: 8px;
  @media screen and (max-width: 424px) {
    margin-bottom: 8px;
    min-height: 36px;
  }

`
export const _Value = styled.span`
  font-size: 38px;
`
export const _Unit = styled.span`
  font-size: 16px;
  /*margin-left: 10px;*/
  color: ${TEXT_GREY};
`
export const _Percent = styled.span`
  margin: 0 4px;
  font-size: 16px;
`

export const _Count = styled.span`
 font-size: 14px;
 color: ${TEXT_GREY};
 white-space: nowrap;
`

export const _PriceContainer = styled.div`
  margin-bottom: 8px;

  @media screen and (max-width: 424px) {
    margin-bottom: 8px;
    ${_Value} {
      font-size: 28px;
    }
    ${_Unit} {
      margin-left: 5px;
    }
  }
`

export const _InfoContainer = styled.div`
  line-height: 26px;
  margin-left: ${({ printStyle }) => (printStyle ? '8px' : '0')};
  display: ${({ printStyle }) => (printStyle ? 'flex' : 'block')};
  ${({ increase }) => (increase ? `
    svg {
      fill: ${BUTTON_HOVER};
    }
  ` : `
    svg {
      fill: ${TERTIARY_COLOR};
      transform: rotate(180deg);
    }
  `)};
  @media screen and (max-width: 424px) {
    ${_Percent}, ${_Count} {
      font-size: 14px;
      line-height: 22px;
    }
  }

`
export const printStatsCss = css`
  display: flex;
  align-items: flex-end;
  ${_PriceContainer} {
    margin-bottom: 0;
  }
  ${_Value} {
    font-size: 20px;
  }
  ${_InfoContainer} {
    line-height: 1;
  }

`
export const _PrintStats = styled.div`
  ${({ forPrint }) => (forPrint && printStatsCss)}
`

